<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品信息</span>
        <el-button @click="_closeAddProduct()">返回</el-button>
      </div>
      <div class="">
        <el-form :model="addChainProductInfo" :rules="rules" ref="form" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="商品名称" prop="prodName">
                <el-input v-model="addChainProductInfo.prodName" placeholder="必填，请填写商品名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品分组" prop="catalogId">
                <el-select v-model="addChainProductInfo.catalogId" style="width:100%">
                  <el-option label="必填，请选择商品分组" value="" disabled></el-option>
                  <el-option v-for="(item, index) in addChainProductInfo.catalogs" :key="index"
                    :label="item.catalogName" :value="item.catalogId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="单位" prop="unitName">
                <el-input v-model="addChainProductInfo.unitName" placeholder="选填，请填写单位"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model="addChainProductInfo.sort" placeholder="选填，请填写排序"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品简介" prop="prodDesc">
                <el-input type="textarea" :rows="3" v-model="addChainProductInfo.prodDesc" placeholder="必填，请填写商品简介"
                  maxlength="250">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品图片</span>
      </div>
      <div class="">
        <el-form label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品封面">
                <upload-image-url ref="coverImageUpload" :image-count="1"
                  @notifyUploadCoverImage="handleCoverImageUpload">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品轮播">
                <upload-image-url ref="carouselImageUpload" :image-count="3"
                  @notifyUploadCoverImage="handleCarouselImageUpload">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品规格</span>
        <el-button type="primary" size="small" @click="_addChainProductSpec()">
          <i class="el-icon-plus"></i>添加
        </el-button>
      </div>
      <div class="">
        <el-table :data="addChainProductInfo.productSpecs" border style="width:100%">
          <el-table-column prop="specName" label="规格名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specName" placeholder="请输入规格名称"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="specValue" label="规格值" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specValue" placeholder="请输入规格值"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.price" :precision="2" :min="0"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="barCode" label="条形码" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.barCode" placeholder="请输入条形码"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="_openAddDeleteProductSpec(scope.row)">
                删除
              </el-button>
              <el-button v-if="scope.row.isDefault != 'T'" type="primary" size="mini"
                @click="_doAddDefaultProductSpec(addChainProductInfo, scope.row)">
                默认规格
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品扩展</span>
      </div>
      <div class="">
        <el-form label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品状态">
                <el-select v-model="addChainProductInfo.state" style="width:100%">
                  <el-option label="选填，请选择状态" value="" disabled></el-option>
                  <el-option label="未上架" value="1001"></el-option>
                  <el-option label="上架" value="2002"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品详情">
                <RichTextEditor v-model="addChainProductInfo.content" @input="handleContentChange" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="margin-top:20px;text-align:right;">
          <el-button type="warning" @click="_closeAddProduct()">
            取消
          </el-button>
          <el-button type="primary" @click="saveProductInfo()">
            <i class="el-icon-check"></i>保存
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/system/UploadImageUrl'
import RichTextEditor from '@/components/system/RichTextEditor.vue'
import { getDict } from '@/api/shop/shopApi'
import { listChainSupplierCatalog } from '@/api/admin/chainSupplierCatalog/chainSupplierCatalogApi'
import { saveChainProduct } from '@/api/admin/chainProduct/chainProductApi'

export default {
  name: 'AddChainProduct',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      addChainProductInfo: {
        productId: '',
        catalogId: '',
        prodName: '',
        prodDesc: '',
        unitName: '',
        sort: '',
        catalogs: [],
        content: '',
        states: [],
        state: '',
        coverPhoto: '',
        carouselFigurePhoto: [],
        productSpecs: [],
        areaCode: '',
        csId: ''
      },
      rules: {
        catalogId: [
          { required: true, message: '商品大类不能为空', trigger: 'change' }
        ],
        prodName: [
          { required: true, message: '商品名称不能为空', trigger: 'blur' },
          { max: 128, message: '商品名称不能超过128位', trigger: 'blur' }
        ],
        prodDesc: [
          { required: true, message: '商品简介不能为空', trigger: 'blur' },
          { max: 256, message: '商品简介不能超过256位', trigger: 'blur' }
        ],
        unitName: [
          { max: 32, message: '单位不能超过32位', trigger: 'blur' }
        ],
        sort: [
          { pattern: /^\d+$/, message: '排序格式错误', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.addChainProductInfo.csId = this.$route.query.csId || ''
    this.initData()
  },
  methods: {
    async initData() {
      try {
        // 获取字典数据
        const { data: dictData } = await getDict('product', 'state')
        this.addChainProductInfo.states = dictData

        // 获取商品分类列表
        this._listAddCatalogs()
      } catch (error) {
        console.error('初始化数据失败:', error)
      }
    },

    handleCoverImageUpload(param) {
      if (param.length > 0) {
        this.addChainProductInfo.coverPhoto = param[0]
      } else {
        this.addChainProductInfo.coverPhoto = ''
      }
    },

    handleCarouselImageUpload(param) {
      this.addChainProductInfo.carouselFigurePhoto = []
      param.forEach(p => {
        this.addChainProductInfo.carouselFigurePhoto.push(p)
      })
    },

    handleContentChange(content) {
      this.addChainProductInfo.content = content
    },

    addProductValidate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          resolve(valid)
        })
      })
    },

    async saveProductInfo() {
      try {
        // 检查是否有默认规格
        const flag = this.addChainProductInfo.productSpecs.some(spec => spec.isDefault === 'T')
        if (!flag && this.addChainProductInfo.productSpecs.length > 0) {
          this.$message.warning('未选择默认规格')
          return
        }

        // 表单验证
        const valid = await this.addProductValidate()
        if (!valid) {
          return
        }

        const res = await saveChainProduct(this.addChainProductInfo)
        if (res.code == 0) {
          this.$message.success('添加成功')
          this.clearAddProductInfo()
          this.$router.go(-1)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('保存商品失败:', error)
        this.$message.error('保存商品失败')
      }
    },

    clearAddProductInfo() {
      const catalogs = this.addChainProductInfo.catalogs
      const csId = this.addChainProductInfo.csId
      this.addChainProductInfo = {
        productId: '',
        catalogId: '',
        prodName: '',
        prodDesc: '',
        unitName: '',
        sort: '',
        catalogs: catalogs,
        content: '',
        states: [],
        state: '',
        coverPhoto: '',
        carouselFigurePhoto: [],
        productSpecs: [],
        areaCode: '',
        csId: csId
      }
      this.$refs.form && this.$refs.form.resetFields()
      this.$refs.coverImageUpload && this.$refs.coverImageUpload.clearImages()
      this.$refs.carouselImageUpload && this.$refs.carouselImageUpload.clearImages()
    },

    _closeAddProduct() {
      this.$router.go(-1)
    },

    async _listAddCatalogs() {
      try {
        const params = {
          page: 1,
          row: 50,
          csId: this.addChainProductInfo.csId
        }
        const res = await listChainSupplierCatalog(params)
        this.addChainProductInfo.catalogs = res.data || []
      } catch (error) {
        console.error('获取商品分类失败:', error)
      }
    },

    _addChainProductSpec() {
      const productSpec = {
        specName: '',
        specValue: '',
        price: 0,
        barCode: '',
        isDefault: 'F'
      }

      this.addChainProductInfo.productSpecs.push(productSpec)

      // 如果没有默认规格，设置第一个为默认
      if (!this.addChainProductInfo.productSpecs.some(spec => spec.isDefault === 'T') &&
        this.addChainProductInfo.productSpecs.length > 0) {
        this.addChainProductInfo.productSpecs[0].isDefault = 'T'
      }
    },

    _openAddDeleteProductSpec(productSpec) {
      const index = this.addChainProductInfo.productSpecs.indexOf(productSpec)
      if (index > -1) {
        this.addChainProductInfo.productSpecs.splice(index, 1)
      }

      // 如果没有默认规格，设置第一个为默认
      if (!this.addChainProductInfo.productSpecs.some(spec => spec.isDefault === 'T') &&
        this.addChainProductInfo.productSpecs.length > 0) {
        this.addChainProductInfo.productSpecs[0].isDefault = 'T'
      }
    },

    _doAddDefaultProductSpec(product, defaultProductSpec) {
      product.productSpecs.forEach(item => {
        item.isDefault = 'F'
      })
      defaultProductSpec.isDefault = 'T'
      this.addChainProductInfo.productSpecs = JSON.parse(JSON.stringify(product.productSpecs))
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
  align-items: center;
}
</style>

